import { Permission } from '@cims-online/shared'
import { RestoreRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { PayItemConnectionGroup, useGroupsContext } from '../../GroupsContext'
import { useRestorePayItemConnectionGroupMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleRestoreNotification } from 'hooks/notificationHandler'

export function useRestore(): RestoreRowActionOptions<PayItemConnectionGroup> {
  const { refetch } = useGroupsContext()
  const [restore] = useRestorePayItemConnectionGroupMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      restorePayItemConnectionGroup: {
        payItemConnectionGroup: { name },
      },
    }) => simpleRestoreNotification(name),
  })
  return {
    permission: Permission.RemoveRestorePayItemConnectionGroup,
    default: 'active',
    metadata: ({ deleted, deletedDate, deletedUser }) => ({
      removed: deleted,
      removedBy: deletedUser,
      removedDate: deletedDate,
    }),
    onRestore: async ({ id }) => {
      await restore({ variables: { id } })
      refetch()
    },
  }
}
